<template>
    <div id="secure">
        <!-- START NAV -->
        <TopMenu />
        <!-- END NAV -->
        <div class="container">
            <div class="columns">
                <div class="column is-12">
                    <nav class="breadcrumb" aria-label="breadcrumbs">
                        <ul>
                            <li>
                                <a v-on:click="goHome()">Super Admin</a>
                            </li>
                            <li>
                                <a v-on:click="goSchools()">Schools</a>
                            </li>
                            <li class="is-active">
                                <a href="#" aria-current="page">{{ schoolName }}</a>
                            </li>
                        </ul>
                    </nav>
                    <section class="info-tiles">
                        <div class="card">
                            <header class="card-header">
                                <loading
                                    :active.sync="isLoading1"
                                    :can-cancel="false"
                                    :is-full-page="false">
                                </loading>
                                <div class="tile is-ancestor has-text-centered">
                                    <div class="tile is-parent">
                                        <article class="tile is-child box">
                                            <p class="title">{{ classCount }}</p>
                                            <p class="subtitle">Classes</p>
                                        </article>
                                    </div>
                                    <div class="tile is-parent">
                                        <article class="tile is-child box">
                                            <p class="title">{{ teacherCount }}</p>
                                            <p class="subtitle">Teachers</p>
                                        </article>
                                    </div>
                                    <div class="tile is-parent">
                                        <article class="tile is-child box">
                                            <p class="title">{{ studentCount }}</p>
                                            <p class="subtitle">Students</p>
                                        </article>
                                    </div>
                                    <div class="tile is-parent">
                                        <article class="tile is-child box">
                                            <p class="title">{{ behaviorCount }}</p>
                                            <p class="subtitle">Behaviors</p>
                                        </article>
                                    </div>
                                    <div class="tile is-parent">
                                        <article class="tile is-child box">
                                            <p class="title">{{ submissionCount }}</p>
                                            <p class="subtitle">Submissions This Year</p>
                                        </article>
                                    </div>
                                </div>
                            </header>
                        </div>
                    </section>
                    <div class="columns">
                        <div class="column is-12">
                            <div class="card events-card">
                                <header class="card-header">
                                    <figure class="image is-128x128">
                                        <img img v-bind:src="this.schoolLogo" alt="School logo" width="128">
                                    </figure>
                                    <p class="card-header-title"><b>{{ schoolName }}</b>, {{ schoolInfo.address }}, {{ schoolInfo.countryLabel }}</p>
                                </header>
                                <div class="card-content">

                                    <b-tabs v-model="activeTab">
                                        <b-tab-item label="School Details">
                                            <loading
                                                :active.sync="isLoading2"
                                                :can-cancel="false"
                                                :is-full-page="false">
                                            </loading>
                                            <div class="content">
                                                <div class="field">
                                                    Address: <b>{{ schoolInfo.address }}</b><br/>
                                                </div>
                                                <div class="field">
                                                    Registered On: <b>{{ moment(schoolInfo.addedOn).format('LLLL') }}</b><br/>
                                                </div>
                                                <div class="field">
                                                    <div class="control">
                                                        <b-select id="plan" name="plan" v-model="schoolPlan">
                                                            <option value="1">PREMIUM UNLIMITED BEHAVIOR</option>
                                                            <option value="2">PREMIUM UNLIMITED BEHAVIOR (1 MONTH TRIAL)</option>
                                                            <option value="3">ATTENDANCE UNLIMITED ( FREE FOREVER)</option>
                                                        </b-select>
                                                    </div>
                                                </div>
                                                <div class="field">
                                                    <div class="control">
                                                        <b-select id="plan" name="plan" v-model="schoolStatus">
                                                            <option value="1">ACTIVE</option>
                                                            <option value="-1">INACTIVE</option>
                                                            <option value="9">MARK THIS SCHOOL AS A TEST SCHOOL</option>
                                                        </b-select>
                                                    </div>
                                                </div>
                                                <div class="field">
                                                    <div class="control">
                                                        <b-select id="enableLiveLeaderboard" name="enableLiveLeaderboard" v-model="enableLiveLeaderboard">
                                                            <option value="0">Disable Live Leaderboard</option>
                                                            <option value="1">Enable Live Leaderboard</option>
                                                        </b-select>
                                                    </div>
                                                </div>
                                                <footer class="card-footer">
                                                    <a v-on:click="updateSchoolInfo()" class="card-footer-item">Save</a>
                                                    <a v-on:click="deleteSchool()" class="card-footer-item">Delete School</a>
                                                </footer>
                                            </div>
                                        </b-tab-item>

                                        <b-tab-item label="Admins">
                                            <loading
                                                :active.sync="isLoading3"
                                                :can-cancel="false"
                                                :is-full-page="false">
                                            </loading>
                                            <div class="content">
                                                <table class="table is-fullwidth is-striped">
                                                    <tbody>
                                                        <tr v-for="admin in listAdmin" :key="admin._id">
                                                            <td><b>{{ admin.firstName }}</b></td>
                                                            <td><b>{{ admin.email }}</b></td>
                                                            <td><b>{{ displayContactNo(admin) }}</b></td>
                                                            <td class="level-right">
                                                                <a class="button is-small is-warning" v-on:click="resetPassword(admin)">Reset Password</a>
                                                                <!-- <a class="button is-small is-danger" v-on:click="removeAdmin(admin._id)">Remove Admin</a> -->
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </b-tab-item>

                                        <b-tab-item label="Add Admin">
                                            <loading
                                                :active.sync="isLoading4"
                                                :can-cancel="false"
                                                :is-full-page="false">
                                            </loading>
                                            <div class="content">
                                                <h5>Create admin to manage the school. For security purposes, don't create too many admins for the school and always remove the admins that you will not be using anymore.</h5>
                                                <div class="field">
                                                    <div class="control">
                                                        <input class="input is-small" type="email" placeholder="Login Email" v-model="newAdminEmail">
                                                    </div>
                                                </div>
                                                <div class="field">
                                                    <div class="control">
                                                        <input class="input is-small" type="password" placeholder="Password" v-model="newAdminPassword">
                                                    </div>
                                                </div>
                                                <div class="field">
                                                    <div class="control">
                                                        <input class="input is-small" type="password" placeholder="Password (again, to confirm)" v-model="newAdminPassword2">
                                                    </div>
                                                </div>
                                                <button class="button is-block is-primary is-fullwidth is-small" v-on:click="createAdmin()">Create Admin</button>
                                            </div>
                                        </b-tab-item>

                                        <b-tab-item label="Functions Log">
                                            <loading
                                                :active.sync="isLoading6"
                                                :can-cancel="false"
                                                :is-full-page="false">
                                            </loading>
                                            
                                            <b-select id="what" what="plan" v-model="what" size="is-small">
                                                <option value="behaviors/update">Behaviors > Update</option>
                                            </b-select>
                                            <br/>

                                            <div class="content">
                                                <div class="columns" v-for="log in functionsLog" :key="log._id">
                                                    <div class="column is-2">{{ moment(log.addedOn).format('LLLL') }}</div>
                                                    <div class="column is-2">{{ log.email }}</div>
                                                    <div class="column is-10"><pre>{{ log.content }}</pre></div>
                                                </div>
                                            </div>
                                        </b-tab-item>

                                        <b-tab-item label="Admin Log">
                                            <loading
                                                :active.sync="isLoading5"
                                                :can-cancel="false"
                                                :is-full-page="false">
                                            </loading>
                                            <div class="content">
                                                <table class="table is-fullwidth is-striped">
                                                    <tbody>
                                                        <tr v-for="log in listLog" :key="log._id">
                                                            <td><b>{{ log.userEmail }}</b></td>
                                                            <td><b>{{ log.action }}</b></td>
                                                            <td><b>{{ log.ip }}</b></td>
                                                            <td><b>{{ moment(log.addedOn).format('LLLL') }}</b></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </b-tab-item>

                                    </b-tabs>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TopMenu from "./TopMenu";
import axios from "axios";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { ToastProgrammatic as Toast } from 'buefy'

export default {
    name: "SuperSchoolEdit",
    components: {
        TopMenu,
        Loading
    },
    data() {
        return {
            superId: "",
            superEmail: "",
            schoolID: "",
            schoolName: "",
            schoolLogo: "",
            schoolInfo: "",
            schoolPlan: 1,
            enableLiveLeaderboard: 0,
            schoolStatus: 1,
            schoolRegisteredOn: '',
            listAdmin: [],
            listLog: [],
            functionsLog: [],
            isLoading1: false,
            isLoading2: false,
            isLoading3: false,
            isLoading4: false,
            isLoading5: false,
            isLoading6: false,
            classCount: 0,
            teacherCount: 0,
            studentCount: 0,
            behaviorCount: 0,
            submissionCount: 0,
            activeTab: 0,
            newAdminEmail: "",
            newAdminPassword: "",
            newAdminPassword2: "",
            what: "behaviors/update"
        };
    },
    created() {
        this.superId = localStorage.getItem("superId");
        this.superEmail = localStorage.getItem("superEmail");

        this.schoolID = this.$store.getters.getSuperViewSchoolID;
        if (this.schoolID.trim.length < 1){
            this.schoolID = localStorage.getItem('SUPER_VIEW_SCHOOL_ID')
        }
        console.log("190 this.schoolID: " + this.schoolID)

        this.schoolName = this.$store.getters.getSuperViewSchoolName;
        if (this.schoolName.trim.length < 1){
            this.schoolName = localStorage.getItem('SUPER_VIEW_SCHOOL_NAME')
        }
        console.log("196 this.schoolName: " + this.schoolName)

        this.schoolLogo = localStorage.getItem('schoolLogo')

        this.getSchoolStats();
        this.getSchoolInfo();
        this.getSchoolAdmins();
        this.getLog();
        this.getFunctionsLog();
    },
    beforeMount() {
        this.$emit("authenticated", true);
    },
    mounted() {},
    methods: {
        getSchoolStats() {
            //this should be cached daily
            let self = this;
            self.isLoading1 = true;

            axios.defaults.headers.common["Authorization"] = localStorage.getItem("jwtToken");
            axios.defaults.responseType = "json";
            axios.post(process.env.MY_URL + "/super/stats", {
                    superEmail: localStorage.getItem("superEmail"),
                    page: "schoolEdit",
                    itemID: self.schoolID
                })
                .then(response => {
                    if (response.data.success == true) {
                        self.classCount = response.data.classCount
                        self.teacherCount = response.data.teacherCount
                        self.studentCount = response.data.studentCount
                        self.behaviorCount = response.data.behaviorCount
                        self.submissionCount = response.data.submissionCount
                    } else {
                        Toast.open({
                            message: e.response.data.msg,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    }
                    self.isLoading1 = false;
                })
                .catch(e => {
                    console.log(e.response);
                    if (e.response.status == 400) {
                        Toast.open({
                            message: e.response.data.msg,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    } else {
                        Toast.open({
                            message:
                                "Sorry, an error has occurred. Please try again: " + e.response.statusText,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    }
                    self.isLoading1 = false;
                });
        },
        getSchoolInfo() {
            let self = this;
            self.isLoading2 = true;

            axios.defaults.headers.common["Authorization"] = localStorage.getItem("jwtToken");
            axios.defaults.responseType = "json";
            axios.post(process.env.MY_URL + "/super/school/info", {
                    superEmail: localStorage.getItem("superEmail"),
                    schoolID: self.schoolID
                })
                .then(response => {
                    if (response.data.success == true) {
                        self.schoolInfo = response.data.schoolInfo
                        self.schoolPlan = self.schoolInfo.plan
                        self.enableLiveLeaderboard = self.schoolInfo.enableLiveLeaderboard
                        self.schoolStatus = self.schoolInfo.status
                        console.log("315 self.enableLiveLeaderboard: " + self.enableLiveLeaderboard)
                    } else {
                        Toast.open({
                            message: e.response.data.msg,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    }
                    self.isLoading2 = false;
                })
                .catch(e => {
                    console.log(e.response);
                    if (e.response.status == 400) {
                        Toast.open({
                            message: e.response.data.msg,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    } else {
                        Toast.open({
                            message:
                                "Sorry, an error has occurred. Please try again: " + e.response.statusText,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    }
                    self.isLoading2 = false;
                });
        },
        getSchoolAdmins() {
            let self = this;
            self.isLoading3 = true;

            axios.defaults.headers.common["Authorization"] = localStorage.getItem("jwtToken");
            axios.defaults.responseType = "json";
            axios.post(process.env.MY_URL + "/super/school/admin/list", {
                    superEmail: localStorage.getItem("superEmail"),
                    schoolID: self.schoolID
                })
                .then(response => {
                    if (response.data.success == true) {
                        self.listAdmin = response.data.listAdmin
                    } else {
                        Toast.open({
                            message: e.response.data.msg,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    }
                    self.isLoading3 = false;
                })
                .catch(e => {
                    console.log(e.response);
                    if (e.response.status == 400) {
                        Toast.open({
                            message: e.response.data.msg,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    } else {
                        Toast.open({
                            message:
                                "Sorry, an error has occurred. Please try again: " + e.response.statusText,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    }
                    self.isLoading3 = false;
                });
        },
        getLog() {
            let self = this;
            self.isLoading5 = true;
            self.listLog = [];

            axios.defaults.headers.common["Authorization"] = localStorage.getItem("jwtToken");
            axios.defaults.responseType = "json";
            axios.post(process.env.MY_URL + "/super/school/admin/log", {
                    superEmail: localStorage.getItem("superEmail"),
                    schoolID: self.schoolID,
                    what: "login"
                })
                .then(response => {
                    if (response.data.success == true) {
                        self.listLog = response.data.listLog
                    } else {
                        Toast.open({
                            message: e.response.data.msg,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    }
                    self.isLoading5 = false;
                })
                .catch(e => {
                    console.log(e.response);
                    if (e.response.status == 400) {
                        Toast.open({
                            message: e.response.data.msg,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    } else {
                        Toast.open({
                            message:
                                "Sorry, an error has occurred. Please try again: " + e.response.statusText,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    }
                    self.isLoading5 = false;
                });
        },
        getFunctionsLog() {
            let self = this;
            self.isLoading6 = true;
            self.listLog = [];

            axios.defaults.headers.common["Authorization"] = localStorage.getItem("jwtToken");
            axios.defaults.responseType = "json";
            axios.post(process.env.MY_URL + "/super/school/admin/log", {
                    superEmail: localStorage.getItem("superEmail"),
                    schoolID: self.schoolID,
                    what: "behaviors/update"
                })
                .then(response => {
                    if (response.data.success == true) {
                        self.functionsLog = response.data.listLog
                    } else {
                        Toast.open({
                            message: e.response.data.msg,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    }
                    self.isLoading6 = false;
                })
                .catch(e => {
                    console.log(e.response);
                    if (e.response.status == 400) {
                        Toast.open({
                            message: e.response.data.msg,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    } else {
                        Toast.open({
                            message:
                                "Sorry, an error has occurred. Please try again: " + e.response.statusText,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    }
                    self.isLoading6 = false;
                });
        },
        updateSchoolInfo(){
            let self = this
            this.$swal({
                title: "Are you sure?",
                text: "Update the school with (any) changes that you made?",
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                showCloseButton: true
            }).then((result) => {
                if (result.value){
                    self.isLoading2 = true;
                    axios.defaults.headers.common["Authorization"] = localStorage.getItem("jwtToken");
                    axios.defaults.responseType = "json";
                    axios.post(process.env.MY_URL + "/super/school/update", {
                            superEmail: localStorage.getItem("superEmail"),
                            schoolID: self.schoolID,
                            plan: self.schoolPlan,
                            enableLiveLeaderboard: self.enableLiveLeaderboard,
                            status: self.schoolStatus
                        })
                        .then(response => {
                            if (response.data.success == true) {
                                Toast.open({
                                    message: response.data.msg,
                                    type: 'is-success',
                                    duration: 3000
                                })
                            } else {
                                Toast.open({
                                    message: e.response.data.msg,
                                    type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                });
                            }
                            self.isLoading2 = false;
                        })
                        .catch(e => {
                            console.log(e.response);
                            if (e.response.status == 400) {
                                Toast.open({
                                    message: e.response.data.msg,
                                    type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                });
                            } else {
                                Toast.open({
                                    message: "Sorry, an error has occurred. Please try again: " + e.response.statusText,
                                    type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                });
                            }
                            self.isLoading2 = false;
                        });
                }
            })
        },
        deleteSchool(){
            let self = this
            self.isLoading2 = true;
            this.$swal({
                title: "Are you sure? ",
                text: self.schoolName + " and ALL IT'S DATA including teachers, classes, students and submissions data will be PERMANENTLY REMOVED. This action CANNOT BE UNDONE. If you're sure, enter your [superadmin login email_remove_this_school]  below to proceed. For example if your superadmin login email is superman@studentqr.com, enter superman@studentqr.com_remove_this_school",
                input: 'text',
                showCancelButton: true,
                inputValidator: (value) => {
                    var removeSchoolValidation = localStorage.getItem('superEmail') + "_remove_this_school"
                    console.log("removeSchoolValidation: " + removeSchoolValidation)
                    if (value == removeSchoolValidation){
                        axios.defaults.headers.common["Authorization"] = localStorage.getItem("jwtToken");
                        axios.defaults.responseType = "json";
                        axios.post(process.env.MY_URL + "/super/school/remove", {
                                superEmail: localStorage.getItem("superEmail"),
                                schoolID: self.schoolID
                            })
                            .then(response => {
                                console.log("imini 44")
                                console.log("imini response: ")
                                console.log(response)

                                if (response.data.success == false) {
                                    Toast.open({
                                        message: response.data.msg,
                                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                        duration: 5000
                                    })
                                } else {
                                    Toast.open({
                                        message: response.data.msg,
                                        type: 'is-success',
                                        duration: 3000
                                    })
                                }
                                self.isLoading2 = false;
                            })
                            .catch(e => {
                                console.log(e.response);
                                if (e.response.status == 400) {
                                    Toast.open({
                                        message: e.response.data.msg,
                                        type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                        duration: 5000
                                    });
                                } else {
                                    Toast.open({
                                        message: "Sorry, an error has occurred. Please try again: " + e.response.statusText,
                                        type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                        duration: 5000
                                    });
                                }
                                self.isLoading2 = false;
                            })
                    }else{
                        Toast.open({
                            message: "You entered the wrong input. School is not deleted.",
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        })
                        self.isLoading2 = false;
                    }
                }
            });
        },
        createAdmin(){
            let self = this
            try {
                if ( (self.newAdminEmail != undefined) && (self.newAdminEmail.length > 5) && (self.newAdminPassword != undefined) && (self.newAdminPassword.length > 7) ) {

                    if (self.newAdminPassword == self.newAdminPassword2){
                        self.isLoading4 = true
                        axios.defaults.headers.common["Authorization"] = localStorage.getItem("jwtToken");
                        axios.defaults.responseType = "json";
                        axios.post(process.env.MY_URL + "/super/school/admin/create", {
                            superEmail: localStorage.getItem("superEmail"),
                            schoolID: self.schoolID,
                            adminEmail: self.newAdminEmail,
                            adminPassword: self.newAdminPassword
                        })
                        .then(response => {
                            console.log("imini 509")
                            console.log("imini response: ")
                            console.log(response)

                            if (response.data.success == false) {
                                Toast.open({
                                    message: response.data.msg,
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                })
                            } else {
                                Toast.open({
                                    message: response.data.msg,
                                    type: 'is-success',
                                    duration: 3000
                                })
                            }
                            self.isLoading4 = false;
                            self.getSchoolAdmins()  //reload the list of admins
                        })
                        .catch(e => {
                            console.log(e.response);
                            if (e.response.status == 400) {
                                Toast.open({
                                    message: e.response.data.msg,
                                    type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                });
                            } else {
                                Toast.open({
                                    message: "Sorry, an error has occurred. Please try again: " + e.response.statusText,
                                    type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                });
                            }
                            self.isLoading4 = false;
                        })

                    }else{
                        Toast.open({
                            message: "Please enter the same password in both password fields.",
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 3000
                        })
                        return false;
                    }

                }else{
                    Toast.open({
                        message: "Please enter the e-mail & password (minimum 8 characters).",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 3000
                    })
                    return false;
                }
            }catch(e){
                Toast.open({
                    message: "Sorry, an error has occurred. Please try again: " + e,
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }
        },
        resetPassword(admin){
            let self = this
            this.$swal({
                title: "Are you sure?",
                text: "Reset the password for admin " + admin.email + " to 'password'? Don't forget to inform the admin to change his/her password after he/she login",
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                showCloseButton: true
            }).then((result) => {
                if (result.value){
                    console.log("585 imini")
                    axios.defaults.headers.common["Authorization"] = localStorage.getItem("jwtToken");
                    axios.defaults.responseType = "json";
                    axios.post(process.env.MY_URL + "/super/school/admin/resetPassword", {
                            superEmail: localStorage.getItem("superEmail"),
                            adminID: admin._id
                        })
                        .then(response => {
                            if (response.data.success == true) {
                                Toast.open({
                                    message: response.data.msg,
                                    type: 'is-success',
                                    duration: 3000
                                })
                            } else {
                                Toast.open({
                                    message: e.response.data.msg,
                                    type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                });
                            }
                            self.isLoading2 = false;
                        })
                        .catch(e => {
                            console.log(e.response);
                            if (e.response.status == 400) {
                                Toast.open({
                                    message: e.response.data.msg,
                                    type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                });
                            } else {
                                Toast.open({
                                    message: "Sorry, an error has occurred. Please try again: " + e.response.statusText,
                                    type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                });
                            }
                            self.isLoading2 = false;
                        });
                }
            })
        },
        displayContactNo(admin){
            if (admin.isSuperAdmin){
                return "SuperAdmin"
            }else{
                return admin.contactNo
            }
        },
        goHome() {
            this.$router.push({
                name: "SuperHome"
            });
        },
        goSchools() {
            this.$router.push({
                name: "SuperSchools"
            });
        },
    }
};
</script>

<style scoped>
html,
body {
    font-size: 16px;
    line-height: 1.5;
    height: 100%;
    background: #ecf0f3;
}
nav.navbar {
    border-top: 4px solid #276cda;
    margin-bottom: 1rem;
}
.navbar-item.brand-text {
    font-weight: 300;
}
.navbar-item,
.navbar-link {
    font-size: 14px;
    font-weight: 700;
}
.columns {
    width: 100%;
    height: 100%;
    margin-left: 0;
}
.menu-label {
    color: #8f99a3;
    letter-spacing: 1.3;
    font-weight: 700;
}
.menu-list a {
    color: #0f1d38;
    font-size: 14px;
    font-weight: 700;
}
.menu-list a:hover {
    background-color: transparent;
    color: #276cda;
}
.menu-list a.is-active {
    background-color: transparent;
    color: #276cda;
    font-weight: 700;
}
.card {
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.18);
    margin-bottom: 2rem;
}
.card-header-title {
    color: #8f99a3;
    font-weight: 400;
}
.info-tiles {
    margin: 1rem 0;
}
.info-tiles .subtitle {
    font-weight: 300;
    color: #8f99a3;
}
.hero.welcome.is-info {
    background: #36d1dc;
    background: -webkit-linear-gradient(to right, #5b86e5, #36d1dc);
    background: linear-gradient(to right, #5b86e5, #36d1dc);
}
.hero.welcome .title,
.hero.welcome .subtitle {
    color: hsl(192, 17%, 99%);
}
.card .content {
    font-size: 14px;
}
.card-footer-item {
    font-size: 14px;
    font-weight: 700;
    color: #8f99a3;
}
.card-table .table {
    margin-bottom: 0;
}
.events-card .card-table {
    max-height: 250px;
    overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/Super/SchoolEdit.vue